 /*
创建者 魏强(2018.3.8)
盾盾精选
*/
<template>
<div class="mod-selling deeppur">
    <h3 class="mod-selling-title"><span>盾盾精选</span></h3>
    <div class="purple-optim">
        <div class="b">
			<router-link v-for="(item,index) in b" :to="item.url" :key="item.key" v-if="index<2" target="_blank" >
				<img :src="item.atturl" :alt="item.aname" />
			</router-link>
        </div>
        <div class="s">
			<router-link v-for="(item,index) in s" :to="item.url" :key="item.key" v-if="index<5" target="_blank" >
				<img :src="item.atturl" :alt="item.aname" />
			</router-link>
        </div>
    </div>
</div>
</template>
<script>
	export default{
	    props:["data"],
	    data(){
	    	const {b,s} = this.data;
	        return {
	           b,s
	        }
	    }
	}
</script>


// WEBPACK FOOTER //
// gd-selected.vue?1728d9d8